<template>
    <div>
        <div class="blog-aticle" v-for="(item, index) in getArticlesByCategory" :key="index" style="margin-top: 40px; margin-bottom: 10px;">
            <h1>{{item.Title}}</h1>
            <div class="blog-aticle-date">
                <span>{{$datef(item.Time)}}</span>
            </div>
            <div  
                :class="status[index] ? 'blog-aticle-content blog-aticle-content-full' : 'blog-aticle-content'">
                <blog-content
                    :postId = "item.Id">
                </blog-content>
            </div>
            <div class="blog-aticle-summary">
                <!--<div class="blog-aticle-summary-social">
                    <div class="blog-aticle-summary-social-item"><i class="mdi mdi-cards-heart"></i>23423</div>
                    <div class="blog-aticle-summary-social-item"><i class="mdi mdi-eye"></i>23423</div>
                    <div class="blog-aticle-summary-social-item"><i class="mdi mdi-hand-pointing-right"></i>поделиться</div>
                </div>-->
                <div class="blog-aticle-summary-redactor" @click="fullScreen(index)">
                    {{status[index] ? 'Свернуть' : 'Читать полностью...'}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import {mapGetters} from 'vuex';
import BlogContent from './sig-blog-article-content'
export default {
    data() {
        return {
            status:[],
            articlesByCategory:[],
            articles:[]
        }
    },
    props: {
        category:{default:'all'}
    },
    components: {
        'blog-content':BlogContent
    },
    computed : {
        ...mapGetters({
            getArticles:'blog/getArticles'
        }),
        getArticlesByCategory() {
                let articles = [];
                if (this.category === 'all'){
                    for(let i = 0; i < this.getArticles.length; i++) {
                        articles.push(this.getArticles[i]);
                        //this.status.push(false);
                    }
                }
                else {
                    for(let i = 0; i < this.getArticles.length; i++) {
                        if (this.getArticles[i].Category === this.category)
                        {
                            articles.push(this.getArticles[i]);
                            //this.status.push(false);
                        }
                    }
                }
                let newArt = articles.reverse()
                return newArt;
        },
    },
    methods : {
        fullScreen(index) {
            this.$set(this.status, index, !this.status[index])
        }
    },
    mounted() {
    },
    created () {
        this.$store.dispatch('blog/requestArticles');
    }
}
</script>
<style lang="less" scoped>
.blog-aticle
    {
        border-radius: 4px;
        background-color: #324258;
        width: 912px;
        margin-top: 40px;
        padding: 24px 32px 28px 32px;
        box-sizing: border-box;
        display: block;
        
        h1
        {
              font-family: Montserrat;
              font-size: 20px;
              font-weight: bold;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.2;
              letter-spacing: 0.4px;
              text-align: left;
              color: #ffffff;
              margin-bottom: 8px;
        }
        
        span
        {
              font-family: Arimo;
              font-size: 13px;
              font-weight: bold;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.85;
              letter-spacing: 0.4px;
              text-align: left;
              color: #adc7e1;
              margin-right: 20px;
        }
        
        &-text
        {
            margin-top: 28px;
            width: 848px;
            height: 848px;
            overflow: hidden;
            display: block;
            
            textarea
            {
                width: 100%;
                height: 100%;
                resize: none;
                border-radius: 5px;
                border:none;
                padding: 10px;
                box-sizing: border-box;
                font-family: Roboto;
                font-size: 15px;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.6;
                letter-spacing: normal;
            }
        }
        
        &-content
        {
              font-family: Roboto;
              font-size: 15px;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.6;
              letter-spacing: normal;
              text-align: left;
              color: #ffffff;
              margin-top: 28px;
              animation: change-height-min 1s ease-in 1;
            max-height: 120px;
            overflow: hidden; 
        }
        
        &-summary
        {
              display: flex;
              justify-content: space-between;
              font-family: Arimo;
              font-size: 13px;
              font-weight: bold;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.85;
              letter-spacing: 0.4px;
              text-transform: uppercase;
              color: #adc7e1;
              margin-top: 28px;
                
              &-social
              {
                display: flex;
                  
                  &-item
                  {
                      margin-right: 24px;
                      display: flex;
                      align-items: center;
                      cursor: pointer;
                      
                      &:hover
                      {
                          color: #cae9ff;
                      }
                      
                      i 
                      {
                          font-size: 23px;
                          line-height: 1;
                          margin-right: 8px;
                      }
                  }
              }

              &-redactor {
                  cursor: pointer;
              }
        }
    }
.width-mixin-frame(@from,@to){
    from {height: @from;}
    to {height: @to;}
}
@keyframes change-height { 
    from {
        max-height: 0px;
    }
    to {
        max-height: 4000px;
    }
}
@keyframes change-height-min { 
    from {
        max-height: 1000px;
    }
    to {
        max-height: 120px;
    }
}
.blog-aticle-content-full {
    animation: change-height 1s ease-in 1;
    max-height: 100%;
    overflow: auto;
}
</style>
